import useCategoryBlockMover from "./use_category_block_mover";
import React, { useContext } from "react";
import { PaletteContext } from "./palette_context";

const CategoryControls = ({ item }) => {
  const { items, setItems } = useContext(PaletteContext);
  const { canMoveUp, canMoveDown, moveUp, moveDown } = useCategoryBlockMover(item, items, setItems);

  return (
    <div className="category-controls">
      {canMoveUp && (
        <a onClick={moveUp} className="palette-control-handle" title={`${window.i18n.t("source_menu.icon_popovers.move_up")}`}>
          <i className="bi bi-chevron-up"></i>
        </a>
      )}
      {canMoveDown && (
        <a onClick={moveDown} className="palette-control-handle" title={`${window.i18n.t("source_menu.icon_popovers.move_down")}`}>
          <i className="bi bi-chevron-down"></i>
        </a>
      )}
    </div>
  );
};

export default CategoryControls;
